export function LogoMark({ className = "h-9 w-9" }) {
    return (
        <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
            <circle cx="32" cy="32" r="32" fill="#C83232" />
            <path d="M19 26h22v9a11 11 0 0 1-22 0z" fill="#F9F8F6" />
            <path
                d="M41 28h3.5a4.5 4.5 0 0 1 0 9H41v-3h3.5a1.5 1.5 0 0 0 0-3H41z"
                fill="#F9F8F6"
            />
            <rect x="16" y="49" width="28" height="3.5" rx="1.75" fill="#F9F8F6" />
            <path
                d="M26 14v7M32 12v9M38 14v7"
                stroke="#F9F8F6"
                strokeWidth="3"
                strokeLinecap="round"
            />
        </svg>
    );
}

export default function Logo({ light = false }) {
    return (
        <span className="flex items-center gap-2.5">
            <LogoMark className="h-9 w-9 shrink-0" />
            <span className="leading-none">
                <span
                    className={`block font-display text-lg font-extrabold tracking-tight ${
                        light ? "text-bg" : "text-ink"
                    }`}
                >
                    Yuhuku
                </span>
                <span
                    className={`block text-[0.68rem] font-bold uppercase tracking-[0.18em] ${
                        light ? "text-bg/70" : "text-ink-muted"
                    }`}
                >
                    kopi
                </span>
            </span>
        </span>
    );
}